import BaseService from "../BaseService";
import _ from "lodash";

class ProductService extends BaseService {
    list = async (filter) => {
        var data = await this._api.post("/product/list", filter);
        return data;
    };

    get = async (id) => {
        var data = await this._api.get(`/product/get`, { params: { id: id } });
        return data;
    };

    create = async (product) => {
        var data = await this._api.post(`/product/create`, product);
        return data;
    };

    delete = async (id) => {
        var data = await this._api.post(`/product/delete`, { id });
        return data;
    }

    hide = async (id) => {
        var data = await this._api.post(`/product/hide`, { id, hide: true });
        return data;
    }

    unhide = async (id) => {
        var data = await this._api.post(`/product/hide`, { id, hide: false });
        return data;
    }

    bulkHide = async (ids = [], hide = false) => {
        var data = await this._api.post(`/product/bulk_hide`, { ids, hide });
        return data;
    }

    bulkAddTags = async (ids = [], tag_ids = []) => {
        var data = await this._api.post(`/product/bulk_add_tags`, { ids, tag_ids });
        return data;
    }

    bulkRemoveTags = async (ids = [], tag_ids = []) => {
        var data = await this._api.post(`/product/bulk_remove_tags`, { ids, tag_ids });
        return data;
    }

    bulkExportInventory = async (ids = []) => {
        var data = await this._api.post(`/product/bulk_export_inventory`, { ids });
        return data;
    }




    outOfStock = async (id, outOfStock = false) => {
        var data = await this._api.post(`/product/out_of_stock`, { id, out_of_stock: outOfStock });
        return data;
    }




    updateGeneralInfo = async (product) => {
        var data = await this._api.post(`/product/updategeneralinfo`, product);
        return data;
    };

    generateDescriptionAI = async (payload = {}) => {
        var data = await this._api.post(`/product/generatedescriptionai`, payload);
        return data;
    };




}
export default ProductService;
